import { hideScrollbar, media } from '@simplywallst/ui-core';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';
import styled, { css } from 'styled-components';

const column1CSS = css`
  width: 120px;
  ${media.smUp`
    width: 120px;
  `}
  ${media.lgUp`
    width: 90px;
  `}
  ${media.xlUp`
    width: 120px;
  `}
`;

const column2CSS = css`
  width: 220px;
`;

const column3CSS = css`
  width: 360px;
`;

const column4CSS = css`
  width: 100px;

  ${media.lgUp`
    width: 70px;
  `}
`;

const column5CSS = css`
  width: 100px;

  ${media.lgUp`
    width: 70px;
  `}
`;

const column6CSS = css`
  width: 100px;

  ${media.lgUp`
    width: 70px;
  `}
`;

const column7CSS = css`
  width: 70px;
`;

export const FairValueIcon = styled('span')`
  display: inline-block;
  position: relative;
  width: 24px;
  height: 24px;
  ${media.xsDown`
    display: none;
  `}
  &:before {
    content: ' ';
    display: block;
    position: absolute;
    width: 21px;
    height: 15px;
    background: ${({ theme }) => theme.color.whiteRGBA(0.1)};
    border-radius: 2px;
    left: 1px;
    top: 4px;
  }
`;

export const InformationIcon = styled(InformationSolid)`
  cursor: help;
  display: inline-block;
`;

type Props = {
  isSticky?: boolean;
  textAlign?: string;
};

export const TableHeadCell = styled('th')<Props>`
  position: sticky;
  ${({ theme }) => theme.typography.tiny}
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  text-align: ${({ textAlign = 'left' }) => textAlign};
  background-color: ${({ theme }) => theme.color.charcoal};

  &:first-child {
    padding-left: ${({ theme }) => theme.x2spacePx}px;
    ${media.mdDown`
      left: -1px;
      z-index: 1;
      ${({ isSticky }) =>
        isSticky &&
        css`
          box-shadow: 8px 0 5px -2px ${({ theme }) => theme.color.almostBlackRGBA(0.3)};
        `}
    `};
  }
  &:nth-child(5) {
    padding-right: ${({ theme }) => theme.x1spacePx}px;
  }
  &:last-child {
    padding-right: ${({ theme }) => theme.x2spacePx}px;
  }
`;

export const TableHeadRow = styled('tr')`
  white-space: nowrap;
`;

export const TableRowCell = styled('td')<Props>`
  text-align: ${({ textAlign = 'left' }) => textAlign};
  height: ${({ theme }) => theme.x8spacePx}px;
  background-color: ${({ theme }) => theme.color.noir};

  &:first-child {
    ${media.lgUp`
      border-top-left-radius: ${({ theme }) => theme.x1spacePx}px;
      border-bottom-left-radius: ${({ theme }) => theme.x1spacePx}px;
    `}
    ${media.mdDown`
      position: sticky;
      left: -1px;
      z-index: 1;
      ${({ isSticky }) =>
        isSticky &&
        css`
          box-shadow: 8px 0 5px -2px ${({ theme }) => theme.color.almostBlackRGBA(0.3)};
        `}
    `}
  }
  &:last-child {
    ${media.lgUp`
      border-top-right-radius: ${({ theme }) => theme.x1spacePx}px;
      border-bottom-right-radius: ${({ theme }) => theme.x1spacePx}px;
    `}
  }
`;

export const TableRow = styled('tr')`
  height: 75px;

  ${media.lgUp`
    height: auto;

    &:last-child {
      ${TableRowCell} {
        border-bottom: none;
      }
    }
  `}
`;

export const StyledTable = styled('table')`
  width: 100%;
  border-spacing: 0;
  table-layout: auto;

  border-top: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};

  border-collapse: separate;
  border-spacing: 0 ${({ theme }) => theme.x1spacePx}px;

  ${TableHeadCell}, ${TableRowCell} {
    &:nth-child(1) {
      ${column1CSS}
    }
    &:nth-child(2) {
      ${column2CSS}
    }
    &:nth-child(3) {
      ${column3CSS}
    }
    &:nth-child(4) {
      ${column4CSS}
    }
    &:nth-child(5) {
      ${column5CSS}
    }
    &:nth-child(6) {
      ${column6CSS}
    }
    &:nth-child(7) {
      ${column7CSS}
    }
  }
`;

export const ScrollPane = styled('div')`
  ${media.mdDown`
    overflow-x: auto;
  `}
  ${hideScrollbar}
`;
